import { BaseResource } from "./BaseResource";
import { apiResourceUrl } from "@ploy-lib/core";
export class SalespersonResource extends BaseResource {
    pk() {
        return this.salespersonId?.toString();
    }
}
SalespersonResource.urlTemplates = [apiResourceUrl("vendors/{vendorId}/salespersons")];
SalespersonResource.urlRoot = apiResourceUrl("salespersons");
//# sourceMappingURL=SalespersonResource.js.map